// 导入axios
import axios from 'axios'
// import { notification } from 'ant-design-vue';
// 进行一些全局配置
// 请求响应超时时间
axios.defaults.timeout = 30000
let domain = window.location.hostname
let port = '8800'
// ip 上传IP
let ip = 'http://' + domain + ':' + port
// let ip = 'http://' + '192.168.14.86' + ':' + port
// server Ip
let server = 'http://' + domain
// let server = 'http://' + '111.53.214.188:8819'
let safety = ''
let safety2 = ''
let safety3 = ip
let safety4 = server
let safety5 = 
// axios.interceptors.request.use(config => {
//   // 在发送请求之前做些什么
//   //判断是否存在token，如果存在将每个页面header都添加token
//   //if中的值为登陆时存入vuex中的token值
//   //如果存在token值，将token放入请求头‘Authorization’
//   if (localStorage.getItem('userinfo').token) {
//       config.headers.common['token'] = localStorage.getItem('userinfo').token
//   }
//   return config;
// }, error => {
//   // 对请求错误做些什么
//   return Promise.reject(error);
// });
axios.get('/static/config.json', {
  withCredentials: true
}).then((res) => {
  // console.log(res)
  safety = res.data.WD_URL
  safety2 = res.data.LLF_URL
  safety3 = res.data.LLF_URL
  safety5 = res.data.DowUpload

})
export default {
  safety3,
  safety4,
  get: (path = '', data = {}, token = {}) => {
    return new Promise((resolve, reject) => {
      axios.get(safety2 + path, { ...token, responseType: 'blob' })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  get1: (path = '', data = {}, token = {}) => {
    return new Promise((resolve, reject) => {
      axios.get(safety2 + path, {
        params: data
      }, token)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  post: (path = '', data = {}, token = {}) => {
    return new Promise((resolve, reject) => {
      axios.post(safety + path, data, token)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  post1: (path = '', data = {}, token = {}) => {
    return new Promise((resolve, reject) => {
      axios.post(safety + path, data, token)
        .then((response) => {
          // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  post2: (path = '', data = {}, token = {}) => {
    return new Promise((resolve, reject) => {
      axios.post(safety2 + path, data, token)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  post3: (path = '', data = {}, token = {}) => {
    return new Promise((resolve, reject) => {
      axios.post(safety3 + path, data, token)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  dowUpload: () =>  {
  
      return safety5
  }
}



// WEBPACK FOOTER //
// ./src/api/location.js